import { Typography } from '@euler/app/components/typography';
import { StatusColors } from '@euler/components/Colors';
import { memo } from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';

export const DoneButton = memo(
  ({
    text,
    scale = 1,
    style,
    onPress,
  }: {
    text: string;
    scale?: number;
    style?: StyleProp<ViewStyle>;
    onPress?: () => void;
  }) => {
    return (
      <TouchableOpacity
        onPress={onPress}
        css={`
          background-color: ${StatusColors.Success};
          padding: 0px ${14 * scale}px;
          align-items: center;
          justify-content: center;
          border-radius: ${3 * scale}px;
          height: ${28 * scale}px;
        `}
        style={style}
      >
        <Typography.Label regular color="#fff" size={Math.floor(16 * scale)}>
          {text}
        </Typography.Label>
      </TouchableOpacity>
    );
  },
);
